import React from "react";
import { SettingsUpdate } from "./about-us";

const ContactUs = () => <SettingsUpdate type={"contact"} title="Contact Us" />;;

export default ContactUs;
